import { DOCUMENT } from '@angular/common';
import { MatTabGroup } from '@angular/material/tabs';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ProfilesService } from '../profiles.service';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { Category, Course, Profile } from '../profiles.type';
import { FuseConfirmationConfig, FuseConfirmationService } from '@fuse/services/confirmation';
import { FuseCardComponent } from '@fuse/components/card';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  encapsulation  : ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DetailsComponent implements OnInit, OnDestroy {
  @ViewChild('courseSteps', {static: true}) courseSteps: MatTabGroup;
  @ViewChildren(FuseCardComponent, {read: ElementRef}) private _fuseCards: QueryList<ElementRef>;
  categories: Category[];
  profile: Profile;
  currentStep: number = 0;
  drawerMode: 'over' | 'side' = 'side';
  drawerOpened: boolean = true;
  skills;
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  selectedFilter: string = 'all';
  envPubeUrl = environment.envPubUrl;

  /**
   * Constructor
   */
  constructor(
      @Inject(DOCUMENT) private _document: Document,
      private _profilesService: ProfilesService,
      private _changeDetectorRef: ChangeDetectorRef,
      private _elementRef: ElementRef,
      private _fuseMediaWatcherService: FuseMediaWatcherService,
      private _fuseConfirmationService: FuseConfirmationService

  )
  {}

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void
  {
      // Get the categories
    //   this._profilesService.categories$
    //       .pipe(takeUntil(this._unsubscribeAll))
    //       .subscribe((categories: Category[]) => {

    //           // Get the categories
    //           this.categories = categories;

    //           // Mark for check
    //           this._changeDetectorRef.markForCheck();
    //       });

      // Get the course
      this._profilesService.course$
          .pipe(takeUntil(this._unsubscribeAll))
          .subscribe((res: any) => {

              // Get the course
              this.profile = res.hireProfile;

              console.log("profile <<<<");
              console.log(this.profile);

              this.skills = res.hireSkills[0];
              this.skills.push({id: 0, name: "All"});
              this.skills.sort(function(a, b) {
                return +a.id - +b.id;
              });
              // Go to step
            //   this.goToStep(profile.progress.currentStep);

              // Mark for check
              this._changeDetectorRef.markForCheck();
          });

  }

  /**
   * On destroy
   */
  ngOnDestroy(): void
  {
      // Unsubscribe from all subscriptions
      this._unsubscribeAll.next(null);
      this._unsubscribeAll.complete();
  }


viewPortfolioImgs(hirePortfolio, i) {
    const data: FuseConfirmationConfig = {
        "title": hirePortfolio.title,
        "message": "<img class='rounded object-cover' src=\"https://storage.googleapis.com/eseel_publicend_inventory/" + this.profile.store.online_id + "/portfolios/" + hirePortfolio.id + "/" + hirePortfolio.hirePortfolioImgs[i].id + "/" + hirePortfolio.hirePortfolioImgs[i].name + "_3x." + hirePortfolio.hirePortfolioImgs[i].ext + "\" alt=\"Card cover image\" >" ,
        "icon": {
          "show": false,
          "name": "heroicons_outline:exclamation",
          "color": "warn"
        },
        "actions": {
          "confirm": {
            "show": false,
            "label": "Remove",
            "color": "warn"
          },
          "cancel": {
            "show": true,
            "label": "Close"
          }
        },
        "dismissible": true
      }
this._fuseConfirmationService.open(data);


}

addAllFilters() {
 var classes = "filter-0 ";
this.skills.forEach(elm => {
  classes += "filter-" + elm.id + " ";
});
return classes;
}

addFilters(hirePortfolio) {
  var classes = "filter-0 ";
  hirePortfolio.hireSkills.forEach(elm => {
   classes += "filter-" + elm.id + " ";
 });
 return classes;
 }

    /**
     * On filter change
     *
     * @param change
     */
     onFilterChange(change: MatButtonToggleChange): void
     {
         // Set the filter
         this.selectedFilter = change.value;
 
         // Filter the cards
         this._filterCards();
     }

     private _filterCards(): void
     {
         // Go through all fuse-cards
         this._fuseCards.forEach((fuseCard) => {
 
             // If the 'all' filter is selected...
             if ( this.selectedFilter === 'all' )
             {
                 // Remove hidden class from all cards
                 fuseCard.nativeElement.classList.remove('hidden');
             }
             // Otherwise...
             else
             {
                 // If the card has the class name that matches the selected filter...
                 if ( fuseCard.nativeElement.classList.contains('filter-' + this.selectedFilter) )
                 {
                     // Remove the hidden class
                     fuseCard.nativeElement.classList.remove('hidden');
                 }
                 // Otherwise
                 else
                 {
                     // Add the hidden class
                     fuseCard.nativeElement.classList.add('hidden');
                 }
             }
         });
     }

}
